import { Dto } from './model-util'

/**
 * Base class for user-facing RMI errors that preserve their type across serialization.
 * Use this when you want the frontend to catch specific error types.
 *
 * The @Dto() decorator registers the class for serialization, allowing instanceof
 * checks to work on the client after deserialization.
 */
@Dto()
export class RmiError extends Error {
	public code: string
	public message: string

	constructor(code: string, message: string) {
		super(message)
		this.code = code
		this.message = message
	}
}

/**
 * Thrown when a requested resource is not found (HTTP 404)
 */
@Dto()
export class NotFoundError extends RmiError {
	constructor(message: string = 'errorResourceNotFound') {
		super('NOT_FOUND', message)
	}
}

/**
 * Thrown when a contractor already has an active contract from the same template (HTTP 409)
 */
@Dto()
export class ContractAlreadyExistsError extends RmiError {
	constructor(message: string = 'errorContractAlreadyExists') {
		super('CONTRACT_ALREADY_EXISTS', message)
	}
}
